import type { Pagination, PaginationUnixTimeStampSecond } from '@/types/app'

const parseUnixtimeSecond = (date: Date): UnixTimeStampSecond =>
  Math.floor(date.getTime() / 1000)

export const createPaginationRequestUnixTimeStampSecond = ({
  since,
  until,
  ...rest
}: Pagination): PaginationUnixTimeStampSecond => ({
  ...rest,
  since: since && parseUnixtimeSecond(since),
  until: until && parseUnixtimeSecond(until),
})
